import { Media } from "@Utilities/Media";
import { SiteSearchBase } from "./SiteSearchBase";
import Enquire from "enquire.js";
import Headroom from "headroom.js";
import MetisMenu from "metismenujs";
import Offcanvas from "bootstrap/js/dist/offcanvas";

export class HeaderBase
{
	public DesktopMenu: HTMLElement;
	public OffCanvasMenuInstance: Offcanvas;
	public OffCanvasMenuEl: HTMLElement;
	public Menu: HTMLElement;
	public MobileMenu: HTMLElement;
	public MobileMenuInstance: MetisMenu;
	public Search: SiteSearchBase;
	public StickyHeader: Headroom;
	public TopMenu: HTMLElement;

	constructor()
	{
		this.Initialize();
	}

	public Initialize(): void
	{
		this.Search = new SiteSearchBase();
		this.ConfigureMobile();
	};

	public ConfigureMyAccountMenu = (accountName: string): void =>
	{
		const myAccountText = document.querySelector(".menu-account .sgn") as HTMLElement;

		//todo: implement getcontent
	};

	public ConfigureCartIcon = (): void =>
	{
		//todo: implement getcontent
	};

	public ConfigureMobile = (): void =>
	{
		Enquire.register(Media.MediaMobile, {
			deferSetup: true,
			match: (): void =>
			{
				this.MenuMobileSetup();
				this.StickyHeaderSetup();
			},
			unmatch: (): void =>
			{
				this.MenuMobileDestroy();
				this.StickyHeaderDestroy();
			}
		});
	};

	public MenuMobileDestroy(): void
	{
		this.DesktopMenu = document.querySelector("#desktopMenu");
		this.Menu = document.querySelector("#menu");
		this.TopMenu = document.querySelector("#topMenu");

		if (this.OffCanvasMenuEl !== null && typeof this.OffCanvasMenuEl !== "undefined")
		{
			if (this.OffCanvasMenuEl.classList.contains("show"))
			{
				this.OffCanvasMenuInstance.hide();
				this.OffCanvasMenuEl.removeEventListener("show.bs.offcanvas", this.MenuMobileOpen);
			}
		}

		if (this.Menu !== null)
		{
			if (this.Menu.classList.contains("metismenu"))
			{
				if (typeof this.MobileMenuInstance !== "undefined")
				{
					this.MobileMenuInstance.dispose();
				}

				this.Menu.classList.remove("metismenu");
			}
		}

		if (this.DesktopMenu !== null)
		{
			this.DesktopMenu.appendChild(this.TopMenu);
		}

		document.querySelectorAll(".nav-unwrap__clone").forEach(element =>
		{
			if (element.parentNode !== null)
			{
				element.parentNode.removeChild(element);
			}
		});
	};

	public MenuMobileOpen = (): void =>
	{
		// setting variables. more happens in each implementation
		this.MobileMenu = document.querySelector("#mobileMenu");
		this.TopMenu = document.querySelector("#topMenu");
	};

	public MenuMobileSetup = (): void =>
	{
		this.OffCanvasMenuEl = document.querySelector("#offCanvasMenu");
		this.OffCanvasMenuInstance = Offcanvas.getOrCreateInstance("#offCanvasMenu");
		this.OffCanvasMenuEl.addEventListener("show.bs.offcanvas", this.MenuMobileOpen, { once: true });
	};

	public StickyHeaderDestroy = (): void =>
	{
		if (typeof this.StickyHeader !== "undefined")
		{
			this.StickyHeader.destroy();
		}
	};

	public StickyHeaderSetup = (): void =>
	{
		const container = document.querySelector(".header-top");

		this.StickyHeader = new Headroom(container, {
			offset: 100,
		});

		this.StickyHeader.init();
	};
}